import { Button, ButtonsGroup, Flex, Modal } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useRecurringInvoiceEmailTemplate } from '../../contexts/recurringInvoiceEmailTemplateContext'

export const RecurringInvoiceEmailTemplateModalFooter = () => {
  const { t } = useTranslation()
  const { closeRecurringInvoiceEmailTemplateModal, saveRecurringInvoiceEmailTemplate } =
    useRecurringInvoiceEmailTemplate()

  const handleCancelButtonClick = useCallback(() => {
    closeRecurringInvoiceEmailTemplateModal()
  }, [closeRecurringInvoiceEmailTemplateModal])
  const handleSaveButtonClick = useCallback(() => {
    saveRecurringInvoiceEmailTemplate()
  }, [saveRecurringInvoiceEmailTemplate])

  return (
    <Modal.Footer>
      <Flex alignItems="center" flexGrow={1} justifyContent="flex-end">
        <ButtonsGroup>
          <Button onClick={handleCancelButtonClick} variant="text">
            {t('cancel')}
          </Button>
          <Button onClick={handleSaveButtonClick}>
            {t('external_invoices.editor.form.recurring_invoice_settings.email_template.modal.button.save.label')}
          </Button>
        </ButtonsGroup>
      </Flex>
    </Modal.Footer>
  )
}
